<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sdG9Op/tc-custom/9783962726935.jpg?1703128475755" alt="This image is the cover for the book The Journal of Submarine Commander von Forstner, The World At War"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Journal of Submarine Commander von Forstner, The World At War
      </h1>
      <p class="bookDescription body article font2">
        <p>Journal of Submarine Commander von Forstner is an autobiographical account of Germany’s first U-boat commander. (Goodreads)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Freiherr von Georg-Günther Forstner
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?44d58857